var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.881,
    height: 77.884,
    viewBox: "0 0 77.881 77.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_62bc672ce0fa1d23adf660f4_check-green-icon",
    "data-name": "62bc672ce0fa1d23adf660f4_check-green-icon",
    d: "M58.62,3.922l.454.9,3.4,9.046a2.628,2.628,0,0,0,1.54,1.54l8.733,3.281A7.9,7.9,0,0,1,77.621,28.1l-.248.767-4.06,8.987a2.632,2.632,0,0,0,0,2.183l3.859,8.5a7.907,7.907,0,0,1-3.21,10.091l-.9.454-9.046,3.4a2.639,2.639,0,0,0-1.534,1.54L59.2,72.751a7.907,7.907,0,0,1-9.412,4.874l-.767-.248-8.987-4.06a2.633,2.633,0,0,0-2.184,0l-8.491,3.859a7.907,7.907,0,0,1-10.091-3.21l-.454-.9-3.4-9.046a2.638,2.638,0,0,0-1.54-1.534L5.133,59.2A7.907,7.907,0,0,1,.259,49.79l.248-.767,4.066-8.987a2.638,2.638,0,0,0,0-2.183L.708,29.361a7.907,7.907,0,0,1,3.2-10.091l.9-.454,9.052-3.411a2.638,2.638,0,0,0,1.54-1.54l3.281-8.733A7.907,7.907,0,0,1,28.094.258l.767.248,8.987,4.066a2.638,2.638,0,0,0,2.184,0l8.5-3.859a7.907,7.907,0,0,1,10.091,3.2Zm-6.9,21.485L32.909,46.887,26.052,40.03a2.638,2.638,0,0,0-3.729,3.729l8.851,8.852a2.638,2.638,0,0,0,3.848-.13l20.653-23.6a2.638,2.638,0,0,0-3.965-3.47Z",
    fill: "#86e9b9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTick);
export default __webpack_public_path__ + "static/media/rightTick.55795a467ea17a5863e3aa1aa294917c.svg";
export { ForwardRef as ReactComponent };